import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  username: string;
  constructor(private router: Router) { }

  ngOnInit(): void {
    
  }

  login() {
    localStorage.setItem('username', this.username?.toLowerCase());
    this.router.navigateByUrl('app');
  }

}
